import { ChangeDetectorRef, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// should only be used as a superclass; this class is not injectable
import { FormFieldComponent } from '../form-field/form-field.component';

export class CustomFormFieldComponent
  extends FormFieldComponent
  implements ControlValueAccessor, OnInit {
  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(changeDetectorRef, translateService);
  }

  propagateChange(_: any) {}

  writeValue(value: any) {
    throw new Error('must be implemented');
  }

  registerOnChange(fn: () => {}) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}
}
